import axios from 'axios';

let cachedRsaPublicKey =null;
let ActiveAesKey = null;

function arrayBufferToBase64(buffer){


  
  const bytes = new Uint8Array(buffer)

  const binary = String.fromCodePoint(...bytes);

  return btoa(binary)



  // let binary = '';
  // for(let i=0 ; i< bytes.byteLength; i++){
  //   binary += String.fromCharCode(bytes[i]);
  // }
}


async function importPublicKey(pemBase64){

  
  const arrayBuf = Base64ToBytes(pemBase64);
  
  return await window.crypto.subtle.importKey(
    'spki',
    arrayBuf,
    {
      name : "RSA-OAEP",
      hash: "SHA-256"
    },
    true,
    ["encrypt"]
  )
}


//AES-GCM key
async function generateAesKey(){
  return await window.crypto.subtle.generateKey(
    {
      name : "AES-GCM",
      length : 256
    },
    true,
    ["encrypt", "decrypt"]
  )
}

async function exportAesKey(aesKey) {
  const exported = await window.crypto.subtle.exportKey("raw",aesKey);
  return new Uint8Array(exported)
}

//public key
async function encryptAesKeyWithRsa(rawAesKey, rsaPublicKey) {
  const encrypted = await window.crypto.subtle.encrypt(
    {
      name : "RSA-OAEP"
    },
    rsaPublicKey,
    rawAesKey
  );
  return new Uint8Array(encrypted)
}



const Base64ToBytes = (base64) =>{

  const binary = atob(base64);
  

  const bytes = new Uint8Array(binary.length);

  for(let i=0 ; i< binary.length ; i++){
    bytes[i] =binary.charCodeAt(i);
  }

  return bytes;
}


//GCM
const encryptAES256= async (plainText , aesKey)=>{
  

  const encoder = new TextEncoder();

  const iv = crypto.getRandomValues(new Uint8Array(12));
  // const keyBytes = Base64ToBytes(process.env.VUE_APP_API)
  

  // const cryptoKey = await crypto.subtle.importKey(
  //   'raw',
  //   aesKey,
  //   {
  //     name:'AES-GCM'
  //   },
  //   false,
  //   ['encrypt']

  // );

  const encryptedBuffer = await window.crypto.subtle.encrypt(
    {
      name : 'AES-GCM',
      iv:iv
    },
    aesKey,
    encoder.encode(plainText)
  )

  const encryptedBytes= new Uint8Array(encryptedBuffer);

  const combined = new Uint8Array(iv.length + encryptedBytes.length);

  combined.set(iv,0);
  combined.set(encryptedBytes,iv.length);

  let binary =''

  combined.forEach(b=>{
    binary += String.fromCharCode(b);
  });

  return btoa(binary);
  
}



// //AES-256 GCM 복호화

const decryptAES256= async (encryptedPayload, aesKey)=>{

  try{
    // const keyBytes = Base64ToBytes(process.env.VUE_APP_API);

    // const cryptoKey = await crypto.subtle.importKey(
    //   'raw',
    //   keyBytes,
    //   {
    //     name:'AES-GCM'
    //   },
    //   false,
    //   ['decrypt']
    // )
    //Base64 decode


    const binary = atob(encryptedPayload);


    

    const combined = Uint8Array.from(
      binary,
      c=> c.charCodeAt(0)
    );
    

    const iv = combined.slice(0,12);
    
    const cipherBytes = combined.slice(12);

    const decryptedBuffer = await crypto.subtle.decrypt(
      {
        name:'AES-GCM',
        iv:iv
      },
      aesKey,
      cipherBytes
    );
  
    return new TextDecoder().decode(decryptedBuffer);
  }catch(e){
    console.error(e)
    return encryptedPayload
  }
  
 
}




const ENCRYPTED_CALL_IDS=[
			'api/v1/auth/verification',
			'api/v1/auth/verificationCode',
			'api/v1/auth/getUser',
			'api/v1/auth/userJoin',
			'api/v1/pin/register',
			'api/v1/pin/verify',
      'api/v1/access/request/list',
			'api/v1/access/request/detail',
			'api/v1/access/request/register',
			'api/v1/access/request/getManager',
			'api/v1/access/request/cancel',
			'api/v1/access/request/updateRegister',
      'api/v1/auth/setChangeDevice',
      'api/v1/access/request/visitor',
			'api/v1/access/method/getMethods',
			'api/v1/access/method/setMethods',






			// 'api/v1/auth/getBiometrics',
			// 'api/v1/auth/updateBiometrics',
			// 'api/v1/access/method/getMethods',
			// 'api/v1/access/method/setMethods',
			// 'api/v1/notice/list',
			// 'api/v1/notice/detail',
			// 'api/v1/faq/list',
			// 'api/v1/terms/list',
			// 'api/v1/terms/detail',
			// 'api/v1/appinfo/license',
			// 'api/v1/faq/read'
		
]


import { useDialog } from '@/assets/js/common'
import router from '@/router/index'
const dialog = useDialog() // 엔진 불러오기

// const back = async () => {
//   // 컨펌 띄우기
//     const isOk = await dialog.alert('잘못된 접근 입니다.')
//     if (isOk) {
//         // router.replace('/access/accessList')
//     }
// }

const apiPlugin = {
  install(app) {
    const axiosInstance = axios.create({
      baseURL: process.env.VUE_APP_API_URL || '',
      timeout: 10000,
      withCredentials: true,
    });

    const mode = process.env.NODE_ENV;
    //20260512
    //세션만료시 자동로그인
    let isRefreshing = false;
    let refreshSubscribers = [];

    //
    const subscribeTokenRefresh = (cb)=>{
      refreshSubscribers.push(cb);
    }

    const onRefreshed = () =>{
      refreshSubscribers.forEach((cb)=>cb());
      refreshSubscribers= [];
    }


    const getRsaPublicKey = async ()=>{
      if(cachedRsaPublicKey) return cachedRsaPublicKey;

      try{
        const response = await axiosInstance.post("api/v1/auth/e2e-public-key");
        const publicKeyBase64 = response?.data?.publicKey;
          if(!publicKeyBase64){
            throw new Error('API 응답이 누락되었습니다.')
          }
          cachedRsaPublicKey = await importPublicKey(publicKeyBase64);
          return cachedRsaPublicKey;
      }catch(error){
        console.error(error)
        
        cachedRsaPublicKey= null;


      }
     
      
      
    }


    axiosInstance.interceptors.response.use(
      (response) => response,
      async (error) =>{
        
        const {config, response} = error;
        const originalRequest = config;

        //401에러이고, 로그인 API 호출 자체가 실패한게 아니라면 자동로그인 시도
        if(response && response.status === 401 && !originalRequest.url.includes('/api/v1/auth/login')){
          
          
          if(!isRefreshing){
          
            isRefreshing = true;
            try{
              
              if(mode==='development'){
                console.log("개발모드 api")
                //개발 모드일때 로컬에서 세션 연결하기 위해
                if(cachedRsaPublicKey==null && ENCRYPTED_CALL_IDS.includes(originalRequest.url)){
                  await getRsaPublicKey()
                  return
                }
                let loginData ={
                };
                loginData.mId = 'M260707000115'
                loginData.uuid = 'IOS_6EA3461A-04EA-4E54-8016-AA341A275EEC'                     
                const rsaPubKey = await getRsaPublicKey();
                const aesKey = await generateAesKey();
                const rawAesKey = await exportAesKey(aesKey);
                const jsonString = JSON.stringify(loginData);

                const encryptedStr = await encryptAES256(jsonString, aesKey );

                //키 암호화

                const encryptedAeskeyBytes = await encryptAesKeyWithRsa(rawAesKey, rsaPubKey);
                const encryptedKeyBase64 = arrayBufferToBase64(encryptedAeskeyBytes);


                const data={
                  encryptedKey : encryptedKeyBase64,
                  body : encryptedStr
                }



                // config.headers ={
                //   ...config.headers,
                //   'Content-Type' : 'text/plain'
                // };


                //2 다시 로그인호출(새로운 세션 발급)
                await axios.post((process.env.VUE_APP_API_URL || '')+ '/api/v1/auth/login', data ,config,{withCredentials : true});
                

                //3 재로그인 성공 -> 큐에 대기중이던 요청들 재실행
                isRefreshing = false;
                onRefreshed();

                //4. 401이 났던 원래 요청도 다시 실행하여 정상결과 반환
                return axiosInstance(originalRequest);
                  
              }else{
                /**세션이 없거나 끊긴 상태에서 개발환경이 아니라면 세션 만료 브릿지 호출*/
                $bridge.sessionInfo();
              }
              


            }catch(retryError){
              //재 로그인마저 실패하면 큐 비우고 에러 반환
              $bridge.sessionInfo();
              isRefreshing = false;
              refreshSubscribers = [];
              
              return Promise.reject(retryError);
            }
          }

          // 다른 api가 이미 재로그인을 진행중이라면, 끝날때 까지 큐에 담아두고 대기
          return new Promise.reject((resolve)=>{
            subscribeTokenRefresh(()=>{
              resolve(axiosInstance(originalRequest));
            });
          });

        }

        return Promise.reject(error);
      }
    )

    /**
     * $api function
     * @param {string} screenId - 화면 아이디
     * @param {string} callId - api id
     * @param {object} data - 페이로드 (optional)
     * @param {function} successCallback - successCallback
     * @param {function} failCallback - Error 핸들러
     * @param {string} method - HTTP Method (default: 'post')
     */
    const $api = async(screenId, callId, data = {}, successCallback, failCallback, method = 'post') => {
      const url = `/${callId}`;

      
      const config = {
        method: method.toLowerCase(),
        url: url,
      };

      //바디 암호화가 필요한 경우 여기서!
      // 메서드에 따라 data 설정, post만 사용할 거 같아서 지워도 될거 같다
      if (config.method === 'get' || config.method === 'delete') {
        config.params = data;
      } else if(config.method === 'post'  && ENCRYPTED_CALL_IDS.includes(callId)){
        //java filter에서 읽을때 텍스트
          const rsaPubKey = await getRsaPublicKey();
          const aesKey = await generateAesKey();
          const rawAesKey = await exportAesKey(aesKey);

          const jsonString = JSON.stringify(data);

          const encryptedStr = await encryptAES256(jsonString, aesKey );

          //키 암호화
                        
          if(cachedRsaPublicKey==null){
            const message ="서버와 연결이 원활하지 않습니다."
            failCallback(message);
            return
          }
          const encryptedAeskeyBytes = await encryptAesKeyWithRsa(rawAesKey, rsaPubKey);
          
          const encryptedKeyBase64 = arrayBufferToBase64(encryptedAeskeyBytes);

          ActiveAesKey = aesKey;

          config.data={
            encryptedKey : encryptedKeyBase64,
            body : encryptedStr
          }
  
      }else{
        config.data = data;
      }

      axiosInstance(config)
        .then(async response  =>{ 
          
          let responseData = response?.data.body;
          if(config.method==='post' && ENCRYPTED_CALL_IDS.includes(callId)){
            if(responseData){
              const decryptedStr =  await decryptAES256(responseData, ActiveAesKey);
              try{
                responseData = JSON.parse(decryptedStr);
              }catch(e){
                responseData = decryptedStr;
              }
            }
          }else{
            //암호화를 사용안하는 경우 data안에 있다

            responseData = response?.data
          }

          if (successCallback) {
            successCallback(responseData);
          }
        })
        .catch( async error => {
          console.log(error)
          let responseData ='';
          
            //백엔드에서 암호화 URL에서 ResponseEntity.status(500)로 응답하면 바디가 암호화해서 오기 때문에 열어서 확인
          if(typeof error.response?.data.body==='string'){
            const decryptedStr = await decryptAES256(error.response?.data?.body , ActiveAesKey);
            try{

              responseData = JSON.parse(decryptedStr);
              
            }catch(e){
              
              responseData = decryptedStr;
            }
          }
          

          // Internal error handling
          const errorInfo = {
            screenId,
            callId,
            status: error.response?.status,
            message: error.response?.data?.message || responseData,
            originalError: error
          };
          
          console.error(`[API Error] ${method.toUpperCase()} ${url}`);
          
          if (errorInfo.status === 403 || errorInfo.status === 401) {
            //응답이 401이면 로그인세션이 만료된 것
            //여기서 공통으로 로그인만료시 해야하는 로직 작성
            //그게 아니면 failCallback 함수 호출

          }

          if (failCallback) {
            failCallback(errorInfo);
          }
        });
    };

    app.config.globalProperties.$api = $api;
    app.provide('$api', $api);
    
   //글로벌 설정
    window.$api = $api;
  }
};

export default apiPlugin;
